class RationalNumberMath {
  constructor () {}

  formatNum (num, level = 2) {
    let offset = Math.pow(10, level)
    return parseInt(Math.round(num * offset))
  }

  add (num1, num2, level) {
    num1 = this.formatNum(num1, level)
    num2 = this.formatNum(num2, level)
    return (num1 + num2) / 100
  }

  sub (num1, num2, level) {
    num1 = this.formatNum(num1, level)
    num2 = this.formatNum(num2, level)
    return (num1 - num2) / 100
  }

  mul (num1, num2, level) {
    num1 = this.formatNum(num1, level)
    num2 = this.formatNum(num2, level)

    return (num1 * num2) / (Math.pow(10, level * 2))
  }

  div (num1, num2, level) {
    num1 = this.formatNum(num1, level)
    num2 = this.formatNum(num2, level)

    return (num1 / num2)
  }

  calcVat (num, level = 2) {
    return parseFloat((parseInt(((num * 17) / 100) * 100) / 100).toFixed(level))
  }
}

export default RationalNumberMath



// WEBPACK FOOTER //
// ./src/Helpers/RationalNumberMath.js